import { DRUG_DEV_STATUS_IDS } from '@patsnap/synapse_common_config'
import { computed, defineComponent } from '@vue/composition-api'
export const phase1Status = 'e2c11c24a7ee4b4e81bbde9eb7127c6d'
export const unknownStatus = '055a60cf40bb4b4eb69c41b492c45a03'
const colorMap: Record<number, string> = {
  0: '#DDEBF8',
  1: '#CCEBFF',
  2: '#B4E1FF',
  3: '#99D6FF',
  4: '#66C2FF',
  5: '#67B2EB',
  6: '#3E94DE',
  7: '#1667B8',
  8: '#194FAC',
}

/**
 * 检查是否只有临床不明确的数据
 * @param params
 */
export function checkOnlyHaveUnknownStatus<T extends { dev_status_id: string }>(data: T[]) {
  return data.length === 1 && data[0].dev_status_id === unknownStatus
}
export const BPipelineBar = defineComponent({
  name: 'BPipelineBar',
  i18n: {
    messages: {
      cn: {
        clinicalStageUnknown: '临床阶段不明',
      },
      en: {
        clinicalStageUnknown: 'Unknown clinical stage',
      },
    },
  },
  props: {
    devStatusId: {
      required: true,
      type: String,
    },
    unknownPhase: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const highestDevStatusIndex = computed(() => {
      if (props.unknownPhase) {
        return 6
      }

      return DRUG_DEV_STATUS_IDS.findIndex((i) => i === props.devStatusId)
    })
    const width = computed(() => `${((highestDevStatusIndex.value + 1) / DRUG_DEV_STATUS_IDS.length) * 100}%`)
    return {
      width,
      highestDevStatusIndex,
    }
  },
  render() {
    return (
      <div
        style={{ width: this.width }}
        class={['flex rounded-tr-xl rounded-br-xl relative', { 'border border-blue-default border-dashed': this.unknownPhase }]}
      >
        {Array.from({ length: this.highestDevStatusIndex + 1 }).map((_, i) => {
          return (
            <div
              class="bg-white-default h-3 flex-1 flex items-center"
              style={{
                borderRadius: '0 12px 12px 0',
                paddingRight: '1px',
                marginRight: i === this.highestDevStatusIndex ? '0' : '-10px',
                zIndex: this.highestDevStatusIndex - i,
              }}
            >
              <div class="h-[10px] w-full" style={{ borderRadius: '0 10px 10px 0', background: this.unknownPhase && i > 3 ? '' : colorMap[i] }}></div>
            </div>
          )
        })}
        {this.unknownPhase && (
          <span class="absolute right-0 top-[-6px]" style="transform: translateX(110%);">
            {this.$t('clinicalStageUnknown')}
          </span>
        )}
      </div>
    )
  },
})
